import { computed, signal } from '@preact/signals';

export type GlobalRole = 'admin' | 'manager' | 'cmo' | 'user';

export const currentRole = signal<GlobalRole | null>(null);

type Action =
  | 'users.create'
  | 'users.edit'
  | 'users.delete'
  | 'companies.create'
  | 'companies.edit'
  | 'leads.create'
  | 'leads.edit'
  | 'leads.delete'
  | 'economy.override_viability'
  | 'audit.view'
  | 'objectives.edit'
  | 'agency.view';

const RULES: Record<Action, GlobalRole[]> = {
  'users.create': ['admin', 'manager', 'cmo'],
  'users.edit': ['admin', 'manager', 'cmo'],
  'users.delete': ['admin'],
  'companies.create': ['admin'],
  'companies.edit': ['admin', 'manager', 'cmo'],
  'leads.create': ['admin', 'manager', 'cmo', 'user'],
  'leads.edit': ['admin', 'manager', 'cmo', 'user'],
  'leads.delete': ['admin', 'manager', 'cmo'],
  'economy.override_viability': ['admin', 'cmo'],
  'audit.view': ['admin', 'manager', 'cmo'],
  'objectives.edit': ['admin', 'manager', 'cmo'],
  // Fee y coste de la agencia: solo dirección (mismo guard que el backend).
  'agency.view': ['admin'],
};

export function can(action: Action): boolean {
  const role = currentRole.value;
  if (!role) return false;
  return RULES[action].includes(role);
}

export const isAdmin = computed(() => currentRole.value === 'admin');
export const isManagerOrAdmin = computed(
  () =>
    currentRole.value === 'admin' || currentRole.value === 'manager' || currentRole.value === 'cmo',
);
// Asistente de gestión: solo admin global y CMO (mismo guard que el backend).
export const isCmoOrAdmin = computed(
  () => currentRole.value === 'admin' || currentRole.value === 'cmo',
);
